__webpack_require__.p = "https://frontend-platform-package-core.ui.moostaging.com/";